/** Missing, failed or legacy capability responses keep CMS Vlog product controls closed. */
export function vlogCmsAllowed(value: unknown): boolean {
  if (!value || typeof value !== "object") return false;
  const access = value as Record<string, unknown>;
  return access.enabled === true && access.vlogCms === true;
}
